<template>
    <div class="page">
        <my-scroll scroll-state  ref="myScroll" :page="page" :on-pull="onPull" class="page-container">
            <div slot="scrollList">
                <div class="public-head">
                    <Head></Head>
                    <div class="big-baikuang">
                        <p>{{$t('thisMonth.ThisMonth')}}</p>
                        <span>{{total}}</span>
                    </div>
                </div>
                <div class="public-body">
                    <div class= "Profile-month">
                        <div class="list-box" :class="item.displayStatus" v-for="item in searchList" @click="detail(item)">
                            <p v-if="item.displayStatus==='Stored' || item.displayStatus==='Returns'">{{$t('searchResult.TimeStored')}}: {{item.timeStored ? dateFormat(item.timeStored) : "-"}}<br></p>
                            <p v-if="item.displayStatus==='Collected'">{{$t('searchResult.TimeCollected')}}: {{item.timeCollected ? dateFormat(item.timeCollected) : "-"}}<br></p>
                            <p v-if="item.displayStatus==='Recreated'">{{$t('searchResult.Recreated')}}: {{item.timeCreated ? dateFormat(item.timeCreated) : "-"}}<br></p>
                            <p v-if="item.displayStatus==='ExpiredReturned' || item.displayStatus==='Returned'">{{$t('searchResult.TimeReturned')}}: {{item.timeCollected ? dateFormat(item.timeCollected) : "-"}}<br></p>
                            <span class="express-number">{{item.orderNumber}}</span>
                            <div class="index-body-div">
                                <div class="item-status">
                                    {{$t(item.displayStatus)}}
                                </div>
                                <font class="Exp" :class="$i18n.locale" v-if="item.overdueFlag && item.displayStatus === 'Stored'">{{$t('Exp')}}</font>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </my-scroll>
        <!-- <div class="Profile-back" @click="back()">
            {{$t('common.Back')}}
        </div>
        <bottom></bottom> -->
        <div class="back_bt">
          <button class="back_bt_w" @click="$router.back()">{{$t('common.Back')}}</button>
        </div>
        <bottom></bottom>
    </div>
</template>
<script>
import bottom from '../Bottom.vue'
import MyScroll from '../MyScroll'
import Head from './Head'
export default {
  name: 'ThisMonth',
  components: {bottom, MyScroll, Head},
  data () {
    return {
      p: '',
      span: '',
      searchList: [],
      total: 0,
      locationName: localStorage.getItem('locationName'),
      page: {
        total: 0
      },
      param: null
    }
  },
  created () {
    // 初始化注入&校验时请求页面数据
    let data = new Date()
    let year = data.getFullYear()
    let month = data.getMonth() + 1
    let time = this.getMonthBeginEnd(year, month)
    this.param = {
      timeStoredStart: time.begin,
      timeStoredEnd: time.end,
      page: 0,
      size: 20,
      sort: 'lastUpdatedTime,desc'
    }
    this.getData()
  },
  methods: {
    getData () {
      let vue = this
      this.axios({
        method: 'get',
        url: this.api.queryOrders,
        params: vue.param
      }).then(function (response) {
        vue.pushData(response.data.content)
        vue.total = response.data ? response.data.totalElements : 0
        vue.page.total = response.data.totalPages
      }).catch(function (error) {
        console.log(error)
      })
    },
    pushData (data = null) {
      for (let i = 0; i < data.length; i++) {
        if (data[i]['displayStatus'] === 'Expired returned') {
          data[i]['displayStatus'] = 'ExpiredReturned'
        }
        this.searchList.push(data[i])
      }
    },
    back () {
      this.$router.back()
    },
    getMonthBeginEnd (year, month) {
      if (~~year === 0 || ~~month === 0) {
        throw new Error('年月参数错误')
      }
      const result = {begin: 0, end: 0}
      const target = new Date()
      target.setFullYear(year)
      target.setMonth(month - 1)
      target.setDate(1)
      target.setHours(0)
      target.setMinutes(0)
      target.setSeconds(0)
      target.setMilliseconds(0)
      result.begin = target.getTime()

      const now = new Date()
      if (target.getFullYear() + target.getMonth() >= now.getFullYear() + now.getMonth()) {
        result.end = now.getTime()
        return result
      }

      target.setMonth(month)// 当月的下个月1日 0时0分0秒
      target.setSeconds(-1)// 前1秒,即昨天最后1秒钟,也就是上个月的最后一秒钟
      result.end = target.getTime()
      return result
    },
    dateFormat (time) {
      let monthArr = this.$t('common.monthArr')
      time = new Date(time)
      let m = monthArr[time.getMonth()] // + this.$t('common.space')
      let d = time.getDate() + this.$t('common.dayFormat') + this.$t('common.space')
      let h = time.getHours()
      if (h.toString().length === 1) {
        h = '0' + h
      }
      let mm = time.getMinutes()
      if (mm.toString().length === 1) {
        mm = '0' + mm
      }
      let dateStr = d + m + ', ' + h + ':' + mm
      return dateStr
    },
    onPull () { // 加载回调
      const vue = this
      if (this.param.page < this.page.total) {
        setTimeout(() => {
          vue.param.page++
          // 加载完成
          this.$refs.myScroll.setState(5)
          vue.getData()
        }, 500)
      } else {
        // 没有数据了
        this.$refs.myScroll.setState(7)
      }
    },
    detail (item) {
      let id = item.articleId
      let logisticsId = item.deliverMerchantId
      this.$router.push('/order/details?order=' + id + '&logisticsId=' + logisticsId)
    }
  }
}
</script>

<style src="../../assets/css/bootstrap.css" scoped>
</style>
<style scoped>
    .express-number{
        margin-top: 0.1rem;
        top: -0.1rem !important;
        position: relative;
        overflow-wrap: break-word;
        margin-right: 20px;
    }
    .list-box{
        position:relative;
        width: 100%;
        height: auto !important;
        background-color: #FFFFFF;
        margin-top: 0.11rem;
        -webkit-box-shadow: 0px 0px 20px rgba(0,0,0,0.16);
        box-shadow: 0px 0px 20px rgba(0,0,0,0.16);
        border-radius: 0.1rem !important;
        overflow: hidden;
        padding: 0;
    }
    .Exp{
        position: absolute;
        bottom: 0.10rem;
        left: 2.01rem;
        height: 0.2rem;
        line-height: 0.2rem;
        font-size: 0.125rem;
        float: right;
    }
    .Exp.br{
      left: 1.8rem;
    }
    .Profile-month{
        width: 93.33%;
        height: auto;
        /*min-height: 5.53rem;*/
        margin-top: 0.23rem !important;
        /* background-color: #000000; */
        margin: auto;
        /*overflow:hidden;*/
        margin-bottom: 0.1rem;
    }
    .Profile-month p{
        font-size:0.125rem;
        font-weight:400;
        font-family: 'Poppins-Regular';
        line-height:0.145rem;
        color:rgba(172,172,172,1);
        margin-top: 0.135rem !important;
        margin-left: 6.14% !important;
        text-align: left;
    }
    .Profile-month span{
        font-family: 'Poppins-Regular';
        display: block;
        text-align: left;
        margin-left: 6.14%;
        font-size:0.15rem;
        font-weight:400;
        line-height:0.18rem;
        color:rgba(0,0,0,1);
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .item-status{
        position: absolute;
        /* top: 500px; */
        text-align: center;
        width: 21.29%;
        height: 0.2rem;
        background:rgba(178,70,154,0.5);
        border-radius:20px;
        /* font-size:0.15rem; */
        font-size:0.125rem;
        font-weight:400;
        font-family: 'Poppins-Regular';
        line-height:0.2rem;
        color:rgba(255,255,255,1);
        margin-top: -0.10rem;
        margin-left: 2.52rem;
    }
    .Returns{
        width: 100%;
        height: 0.63rem;
        background-color: #FFFFFF;
        margin-top: 0.11rem;
        box-shadow:0px 0px 20px rgba(0,0,0,0.16);
        border-radius:20px;
        overflow:hidden
    }
    .Returns>div>div{
        position: absolute;
        /* top: 500px; */
        text-align: center;
        /* width: 21.29%; */
        min-width: 21.29%;
        width: max-content;
        /* padding-left: 5px;
        padding-right: 5px; */
        height: 0.2rem;
        /* background:rgba(178,70,154,0.5); */
        border-radius:20px;
        font-size:0.125rem;
        font-weight:400;
        font-family: 'Poppins-Regular';
        line-height:0.22rem;
        /* color:rgba(255,255,255,1); */
        margin-top: -0.10rem;
        margin-left: 2.52rem;
        background: #E6E6E6;
        color: var(--primary-text-color);
    }
    .Collected{
        width: 100%;
        height: 0.63rem;
        background-color: #FFFFFF;
        margin-top: 0.11rem;
        box-shadow:0px 0px 20px rgba(0,0,0,0.16);
        border-radius:20px;
        overflow:hidden;
        padding:0;
    }
    .Collected>div>div{
        position: absolute;
        /* top: 500px; */
        text-align: center;
        width: 21.29%;
        height: 0.2rem;
        /* background:rgba(0,172,78,0.5); */
        border-radius:20px;
        font-size:0.125rem;
        font-weight:400;
        font-family: 'Poppins-Regular';
        line-height:0.22rem;
        /* color:rgba(255,255,255,1); */
        margin-top: -0.10rem;
        margin-left: 2.52rem;
        background: #E8FCEE;
        color: var(--primary-text-color);
    }
    .Stored{
        width: 100%;
        height: 0.63rem;
        background-color: #FFFFFF;
        margin-top: 0.11rem;
        box-shadow:0px 0px 20px rgba(0,0,0,0.16);
        border-radius:20px;
        overflow:hidden;
        margin-left: unset;
    }
    .Stored>div>div{
        position: absolute;
        text-align: center;
        /* top: 500px; */
        width: 21.29%;
        height: 0.2rem;
        /* background:rgba(31,141,197,0.5); */
        border-radius:20px;
        font-size:0.125rem;
        font-weight:400;
        font-family: 'Poppins-Regular';
        line-height:0.22rem;
        /* color:rgba(255,255,255,1); */
        margin-top: -0.10rem;
        margin-left: 2.52rem;
        background: #E8FCEE;
        color: var(--primary-text-color);
    }
    .Created{
        width: 100%;
        height: 0.63rem;
        background-color: #FFFFFF;
        margin-top: 0.11rem;
        box-shadow:0px 0px 20px rgba(0,0,0,0.16);
        border-radius:20px;
        overflow:hidden
    }
    .Created>div>div{
        position: absolute;
        text-align: center;
        /* top: 500px; */
        width: 21.29%;
        height: 0.2rem;
        /* background:#E2A148; */
        border-radius:20px;
        font-size:0.125rem;
        font-weight:400;
        font-family: 'Poppins-Regular';
        line-height:0.22rem;
        /* color:rgba(255,255,255,1); */
        margin-top: -0.10rem;
        margin-left: 2.52rem;
        background: #E8FCEE;
        color: var(--primary-text-color);
    }
    .Returned{
        width: 100%;
        /* height: 0.63rem; */
        min-height: 0.63rem;
        height: auto;
        background-color: #FFFFFF;
        margin-top: 0.11rem;
        box-shadow:0px 0px 20px rgba(0,0,0,0.16);
        border-radius:20px;
        overflow:hidden
    }
    .Returned>div>div{
        position: absolute;
        text-align: center;
        /* top: 500px; */
        width: 21.29%;
        height: 0.2rem;
        /* background:rgba(31,141,197,0.5); */
        border-radius:20px;
        font-size:0.125rem;
        font-weight:400;
        font-family: 'Poppins-Regular';
        line-height:0.22rem;
        /* color:rgba(255,255,255,1); */
        margin-top: -0.10rem;
        margin-left: 2.52rem;
        background: #E8FCEE;
        color: var(--primary-text-color);
    }
    .Arriving{
        width: 100%;
        height: 0.63rem;
        background-color: #FFFFFF;
        margin-top: 0.11rem;
        box-shadow:0px 0px 20px rgba(0,0,0,0.16);
        border-radius:20px;
        overflow:hidden
    }
    .Arriving>div>div{
        position: absolute;
        text-align: center;
        /* top: 500px; */
        width: 21.29%;
        height: 0.2rem;
        /* background:rgba(31,141,197,0.5); */
        border-radius:20px;
        font-size:0.125rem;
        font-weight:400;
        font-family: 'Poppins-Regular';
        line-height:0.22rem;
        /* color:rgba(255,255,255,1); */
        margin-top: -0.10rem;
        margin-left: 2.52rem;
        background: #E6E6E6;
        color: var(--primary-text-color);
    }
    .Profile-back{
        text-align: center;
        position: fixed;
        width: 82.4%;
        height: 0.58rem;
        bottom: 1.5rem;
        /* margin-left: 8.8%; */
        /* margin-top: 0.33rem !important; */
        box-shadow:0px 10px 20px rgba(0,0,0,0.16);
        border-radius:84px;
        background-color: #FFFFFF;
        /* color: #052460; */
        color: var(--primary-inverted-button-text-color);
        font-size:0.2rem;
        /*font-weight:bold;*/
        font-family: Poppins-Bold;
        line-height:0.58rem;
        margin-bottom: 0.19rem !important;
        max-width: 400px;
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
    }
    .public-body{
        min-height: calc(64vh) !important;
        padding-bottom: 1.2rem;
    }
    .big-baikuang{
        border-radius: 0.1rem;
    }
    /*.Expired.returned{*/
    /*    background:rgba(172,172,172,0.5);*/
    /*}*/
    .Expired.returned .item-status{
        /* background:rgba(172,172,172,0.5); */
        background: #E6E6E6 !important;
        color: var(--primary-text-color) !important;
    }
    .ExpiredReturned .item-status{
        /* background:rgba(172,172,172,0.5); */
        background: #E6E6E6 !important;
        color: var(--primary-text-color) !important;
        width: max-content;
        right: 25px;
    }
    .my-scroll{
        /* margin-bottom: 1rem; */
        /* padding-bottom: 1rem; */
    }
    .Profile-back{
        bottom: 0.3rem;
    }
    .Expired.returned div{
        width: 38% !important;
        margin-left: 2rem !important;
    }
    .index-body-div{
        right: -0.3rem;
        top: 20px;
        margin-top: 0;
    }
</style>
<style lang="less" scoped>
  .page {
    .page-container{
      max-height: 100vh;
      max-height: 100svh;
      max-height: 100dvh;
      overflow-y: auto;
    }
    .back_bt {
      position: fixed;
      width: 82%;
      // left: 9%;
      bottom: 0.4rem;
      z-index: 999;
      max-width: 400px;
      left: 50%;
      transform: translateX(-50%);
      .back_bt_w {
        width: 100%;
        height: 0.58rem;
        // background: rgba(255, 255, 255, 1);
        background: var(--primary-inverted-button-bg-color);
        box-shadow: 0rem 0.05rem 0.1rem rgba(0, 0, 0, 0.16);
        opacity: 1;
        border-radius: 0.42rem;
        border: none;
        // color: rgba(5, 36, 96, 1);
        color: var(--primary-inverted-button-text-color);
        line-height: 0.235rem;
        font-size: 0.2rem;
        /*font-weight: bold;*/
        font-family: Poppins-Bold;
      }
      .back_bt_b {
        margin-top: 0.1rem;
        width: 100%;
        height: 0.58rem;
        // background: linear-gradient(113deg, rgba(5, 36, 96, 1) 0%, rgba(31, 157, 197, 1) 100%);
        // background: linear-gradient(to right, #191E96 , #00BEF5 );
        background: linear-gradient(to right, #01BAFF , #01BAFF );
        box-shadow: 0rem 0.05rem 0.1rem rgba(5, 36, 96, 0.3);
        border-radius: 0.42rem;
        border: none;
        color: #ffffff;
        line-height: 0.235rem;
        font-size: 0.2rem;
        /*font-weight: bold;*/
        font-family: Poppins-Bold;
      }
    }
    .bottom {
      position: fixed;
      bottom: 0.06rem;
      max-width: 400px;
      max-width: 400px;
      left: 50%;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
    }
  }
  .loading-container{
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--primary-label-color);
    padding: 10px;
    cursor: pointer;
    gap: 10px;
    font-size: 18px;
  }
  .loading-spinner {
    -webkit-animation:spin 1.5s linear infinite;
    -moz-animation:spin 1.5s linear infinite;
    animation:spin 1.5s linear infinite;
  }
</style>



// WEBPACK FOOTER //
// src/components/Acount/ThisMonth.vue